import React from "react";
import { Helmet } from "react-helmet";
import Layout from "./Layout";

function PageNotFound() {
  return (
    <Layout customClass="content-area">
      <Helmet>
        <title>Page Not Found - Instant QR Codes</title>
        <met name="description" content="Error 404, page not found." />
      </Helmet>
      <h3>Page Not Found :(</h3>
      <p>Sorry, the page you were looking for is not found.</p>
    </Layout>
  );
}

export default PageNotFound;
